/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Box, Paper, Button, Dialog, Typography, IconButton } from '@mui/material';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import { withStyles } from 'tss-react/mui';
import { useStyles } from './styles';
import { IDialog } from '../../models/Dialog/Dialog';
import Divider from '@mui/material/Divider';
import { X } from '@jda/lui-common-icon-library-mui5';
import Loader from '../Loader';
import { AGREE, DISAGREE, CAN_NOT_BE_UNDONE_MESSAGE } from './constants';
import { Tokens } from '@jda/lui-common-component-library-mui5';

const DialogTitle = ({ children }: any) => {
  return (
    <MuiDialogTitle>
      <Box display="flex" alignItems="center">
        <Box flexGrow={1}>
          <Typography variant="h5">{children}</Typography>
        </Box>
      </Box>
    </MuiDialogTitle>
  );
};

const DialogContent = withStyles(MuiDialogContent, _theme => ({
  root: {
    padding: Tokens.spacing['$sp-4']
  }
}));

const DialogActions = withStyles(MuiDialogActions, _theme => ({
  root: {
    background: 'transparent',
    margin: 0,
    padding: Tokens.spacing['$sp-4'],
    justifyContent: 'flex-end',
    '& button': {
      marginLeft: `${Tokens.spacing['$sp-4-5']} !Important`
    }
  }
}));

export const AlertDialog = ({
  primaryButtonText,
  handleOnOk,
  primaryButtonColor,
  secondButtonText,
  dialogContentText,
  handleOnCancel,
  dialogTitle,
  recordName,
  hideCanNotBeUndoneMessage,
  showDialogLoader,
  isStatement,
  additionalContent,
  isPrimaryButtonDisabled = false
}: IDialog) => {
  const { classes } = useStyles();

  return (
    <Paper elevation={0} square>
      <Box>
        <div>
          <Dialog
            id="dial"
            open={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{ scrollPaper: classes.scrollPaper }}
            BackdropProps={{
              classes: {
                root: classes.root
              }
            }}
            PaperProps={{
              classes: {
                root: classes.paper
              }
            }}
          >
            <DialogTitle id="alert-dialog-title">
              <Box>
                <Box className={classes.bold}>{dialogContentText}</Box>
                <IconButton
                  size="small"
                  id="closeBox"
                  classes={{ root: classes.closeBtn }}
                  onClick={() => {
                    handleOnCancel();
                  }}
                >
                  {' '}
                  <X />
                </IconButton>
              </Box>
            </DialogTitle>
            <Divider />
            <DialogContent id="alert-dialog-content">
              <Typography component="span" gutterBottom id="alert-dialog-description">
                {dialogTitle}
                <Typography component="span" className={classes.bold}>
                  {recordName}
                </Typography>
                {!isStatement && <span> ? </span>}
              </Typography>

              {additionalContent}
              {!hideCanNotBeUndoneMessage && <Typography> {CAN_NOT_BE_UNDONE_MESSAGE}</Typography>}

            </DialogContent>
            <Divider />
            <DialogActions id="alert-dialog-action">
              <Loader showLoader={showDialogLoader} isCenter />
              <Button
                variant="outlined"
                onClick={() => {
                  handleOnCancel();
                }}
                color="primary"
                size='small'
                id="buttonCancel"
              >
                {secondButtonText ? secondButtonText : DISAGREE}
              </Button>
              <Button
                id="okBtn"
                // className={
                //   primaryButtonColor === 'primary' ? '' : `${classes.buttonStyle} ${classes.deleteButtonStyler}`
                // }
                onClick={() => handleOnOk()}
                color={primaryButtonColor === 'primary' ? 'primary' : primaryButtonColor === 'error' ? 'error' : undefined  }
                variant="contained"
                size="small"
                disableElevation
                disabled={isPrimaryButtonDisabled || showDialogLoader}
              >
                {primaryButtonText ? primaryButtonText : AGREE}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Box>
    </Paper>
  );
};
